// extracted by mini-css-extract-plugin
export default {"container":"training_container__7wh6O","content":"training_content__6pjoQ"};